/*
 * VORVANI - CART DISCOUNT FORM FIX (2026-09-22)
 *
 * snippets/cart-discount-field.liquid wires its coupon form to
 * onsubmit="handleDiscountForm(event)" and oninput="handleDiscountFormChange(event)",
 * but neither function existed anywhere in the theme's JS. Submitting a discount
 * code threw "ReferenceError: handleDiscountForm is not defined" and the browser
 * fell back to a plain form submit, reloading the page with an empty
 * ?cart-discount-field= query param and never actually applying the code.
 *
 * This file defines both functions globally so the existing markup (rendered
 * both on full page loads and inside AJAX-refreshed cart drawer fragments) works
 * as intended. The discount code is applied via Shopify's native
 * /discount/{code} route in the background (fetch, not a page navigation), and
 * the cart drawer is then refreshed in place using the exact same
 * fetch(`${routes.cart_url}?section_id=cart-drawer`) + replaceWith(...) pattern
 * that CartItems.onCartUpdate() already uses in assets/cart.js -- so applying a
 * code behaves exactly like any other cart change: the lateral drawer stays
 * open, it just never navigates to a full /cart page.
 */
function handleDiscountFormChange(event) {
  var form = event.target.closest('.cart-discount-form');
  if (!form) return;
  form.classList.remove('cart-discount-form--error');
  var errorEl = form.querySelector('.cart-discount-form__error');
  if (errorEl) errorEl.classList.remove('cart-discount-form__error--visible');
}

function handleDiscountForm(event) {
  event.preventDefault();
  var form = event.target;
  var input = form.querySelector('input[name="cart-discount-field"]');
  var code = input ? input.value.trim() : '';

  if (!code) {
    form.classList.add('cart-discount-form--error');
    var errorEl = form.querySelector('.cart-discount-form__error');
    if (errorEl) errorEl.classList.add('cart-discount-form__error--visible');
    if (input) input.focus();
    return false;
  }

  var submitBtn = form.querySelector('button[type="submit"]');
  if (submitBtn) submitBtn.disabled = true;

  var cartUrl = (window.routes && window.routes.cart_url) ? window.routes.cart_url : '/cart';
  var applyUrl = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(cartUrl);

  function refreshCartDrawer() {
    return fetch(cartUrl + '?section_id=cart-drawer')
      .then(function (response) { return response.text(); })
      .then(function (responseText) {
        var html = new DOMParser().parseFromString(responseText, 'text/html');
        var selectors = ['cart-drawer-items', '.cart-drawer__footer'];
        selectors.forEach(function (selector) {
          var targetElement = document.querySelector(selector);
          var sourceElement = html.querySelector(selector);
          if (targetElement && sourceElement) targetElement.replaceWith(sourceElement);
        });
      });
  }

  fetch(applyUrl)
    .then(function (response) {
      if (!response.ok) {
        form.classList.add('cart-discount-form--error');
        var errorEl = form.querySelector('.cart-discount-form__error');
        if (errorEl) errorEl.classList.add('cart-discount-form__error--visible');
      }
      return refreshCartDrawer();
    })
    .catch(function () {
      // Last-resort fallback only if the background flow itself fails.
      window.location.href = applyUrl;
    })
    .finally(function () {
      if (submitBtn) submitBtn.disabled = false;
    });

  return false;
}
